<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Anote">A Note on Usages</a></h2>
<h2 class="toc"><a href="#/xhtml/07_Familytree">Family Tree</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Maincharacters">Main Characters</a></h2>
<h2 class="tocb"><a href="#/xhtml/09_Introduction">Introduction: Against the Stream</a></h2>
<h2 class="toc1"><a href="#/xhtml/10_Chapter01"><span class="space">Chapter 1</span> The Young Trotsky, 1879–1896</a></h2>
<h2 class="toc1"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample"><span class="space">Chapter 2</span> Revolution, Love and Exile, 1897–1902</span></h2>
<h2 class="toc1"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample"><span class="space">Chapter 3</span> Escape, Splits and Revolution, 1902–06</span></h2>
<h2 class="toc1"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample"><span class="space">Chapter 4</span> The Vienna Years, 1907–13</span></h2>
<h2 class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample"><span class="space">Chapter 5</span> War and Internationalism, 1914–17</span></h2>
<h2 class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample"><span class="space">Chapter 6</span> Revolution and Civil War, 1917–19</span></h2>
<h2 class="toc1"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample"><span class="space">Chapter 7</span> The Commissar in Power, 1920–23</span></h2>
<h2 class="toc1"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample"><span class="space">Chapter 8</span> Fighting Against His Time, 1924–28</span></h2>
<h2 class="toc1"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample"><span class="space">Chapter 9</span> Prophet Without a Home, 1929–36</span></h2>
<h2 class="toc1"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample"><span class="space">Chapter 10</span> Love and Death in Mexico, 1937–40</span></h2>
<h2 class="toct"><span href="#/xhtml/20_Conclusion" title="Link target outside of Sample">Conclusion: Legacy</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Bibliography" title="Link target outside of Sample">Bibliography/Further Reading</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Endnotes" title="Link target outside of Sample">Endnotes</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Platesection" title="Link target outside of Sample">Plate Section</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?6d70d892